import { useEffect } from 'react';
import { useSocketStore } from '../../stores/useSocketStore';
import { usePontosItinerarioStore } from '../../stores/usePontosItinerarioStore';

export function usePontosSocket() {
    
    const socket = useSocketStore(state => state.socket);

    useEffect(() => {

        if (!socket) return;

        const {
            upsertPonto,
            deletePonto
        } = usePontosItinerarioStore.getState();

        socket.on('pontoItinerario:upserted', upsertPonto);

        socket.on('pontoItinerario:deleted', deletePonto);

        return () => {
            
            socket.off('pontoItinerario:upserted', upsertPonto);

            socket.off('pontoItinerario:deleted', deletePonto);

        };

    }, [socket]);

}